import { Text } from "./Typography"

type InputErrorMessageProps = {
  message: string
}

export function InputErrorMessage({ message }: InputErrorMessageProps) {
  return (
    <Text color="tabasco" fontFamily="IBMPlexSans-Regular" fontSize={18} lineHeight={29}>
      {message}
    </Text>
  )
}
